document.addEventListener('DOMContentLoaded', function () {
	const citationLinks = document.querySelectorAll('.fpc-citation');

	citationLinks.forEach(function (link) {
		link.addEventListener('click', function (event) {
			if (link.getAttribute('href') === '#') {
				event.preventDefault();
				const citationNumber = link.dataset.citationNumber;
				const citationContent = link.dataset.citationContent;
				createCitationModal(citationNumber, citationContent);
			}
		});
	});
});

function createCitationModal(citationNumber, citationContent) {
	let newModalHolder = document.createElement('div');
	newModalHolder.classList.add('citation-modal-holder', 'modal', 'open');
	document.body.classList.add('modal-open');
	newModalHolder.innerHTML = `
        <div class="modal-bg"></div>
        <div class="modal-dialog pal lg:paxxl has-background has-white-background-color">
            <button class="close-button">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="close">
                        <path id="Vector" d="M12 13.5914L7.19563 18.3957C6.98439 18.607 6.71918 18.7126 6.39998 18.7126C6.08078 18.7126 5.81556 18.607 5.60433 18.3957C5.39309 18.1845 5.28748 17.9193 5.28748 17.6001C5.28748 17.2809 5.39309 17.0157 5.60433 16.8044L10.4087 12.0001L5.60433 7.19575C5.39309 6.98451 5.28748 6.7193 5.28748 6.4001C5.28748 6.0809 5.39309 5.81568 5.60433 5.60445C5.81556 5.39321 6.08078 5.2876 6.39998 5.2876C6.71918 5.2876 6.98439 5.39321 7.19563 5.60445L12 10.4088L16.8043 5.60445C17.0156 5.39321 17.2808 5.2876 17.6 5.2876C17.9192 5.2876 18.1844 5.39321 18.3956 5.60445C18.6069 5.81568 18.7125 6.0809 18.7125 6.4001C18.7125 6.7193 18.6069 6.98451 18.3956 7.19575L13.5913 12.0001L18.3956 16.8044C18.6069 17.0157 18.7125 17.2809 18.7125 17.6001C18.7125 17.9193 18.6069 18.1845 18.3956 18.3957C18.1844 18.607 17.9192 18.7126 17.6 18.7126C17.2808 18.7126 17.0156 18.607 16.8043 18.3957L12 13.5914Z" fill="#0B332E" />
                    </g>
                </svg>
            </button>
            <div class="modal-content citation-modal-content">
                <p><sup>${citationNumber}</sup>${citationContent}</p>
            </div>
        </div>
    `;
	document.body.appendChild(newModalHolder);
	const closeModalControls = document.querySelectorAll(
		'.citation-modal-holder button.close-button, .citation-modal-holder .modal-bg',
	);
	closeModalControls.forEach((button) => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			if (newModalHolder) newModalHolder.remove();
			document.body.classList.remove('modal-open');
		});
	});
}
